import { useEffect, useRef } from "react";
import type { CaptchaAction } from "@ugg/shared/utils/captcha";
import { mintAuthCaptcha } from "@ugg/shared/utils/auth-captcha";

/**
 * Mints auth captcha tokens into a form-owned container. Starting another attempt, calling
 * `cancel`, or unmounting abandons any attempt still in progress.
 */
export function useAuthCaptcha() {
  const containerRef = useRef<HTMLDivElement>(null);
  const controllerRef = useRef<AbortController | null>(null);

  useEffect(() => () => controllerRef.current?.abort(), []);

  const cancel = () => controllerRef.current?.abort();

  const mint = (action: CaptchaAction, setError: (message: string) => void) => {
    controllerRef.current?.abort();
    const controller = new AbortController();
    controllerRef.current = controller;
    return mintAuthCaptcha(action, setError, { container: containerRef.current, signal: controller.signal });
  };

  return { containerRef, mint, cancel };
}
